import { render } from "./BarnamehForm.vue?vue&type=template&id=f03512b0"
import script from "./BarnamehForm.vue?vue&type=script&lang=js"
export * from "./BarnamehForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__